import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const addComplaintGroup = (params) => {
    return axiosPost(
        //appsettings.ocpbComplaintAPIUrl + "api/ComplaintGroup/AddOrUpdateComplaintGroup",params
        "https://localhost:44394/api/ComplaintGroup/AddOrUpdateComplaintGroup",params
    );

}

export{addComplaintGroup}